import AssessmentServiceApi from "../../services/assessment-api";
import FunnelStepTypes from "../funnel-step/types";

const getBulkQuestions = (id, languageCode) => {
  return function (dispatch) {
    return AssessmentServiceApi.getBulkQuestion(id, languageCode)
      .then((response) => {
        if (response) {
          // dispatch(pushResetSelectedAnswerCountToFunnelStep());
          dispatch(PushTotalNumberOfQuestionToFunnelStep(response.length));
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getOneQuestionPerAssessment = (assesmentIds, languageCode) => {
  return function (dispatch) {
    return AssessmentServiceApi.getOneQuestionPerAssessment(
      assesmentIds,
      languageCode
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getCareerContent = (personalityId) => {
  return function (dispatch) {
    return AssessmentServiceApi.getCareerContent(personalityId)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const saveUserAnswer = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.createUserAnswer(data)
      .then((response) => {
        if (response) {
          const { funnelStep } = getState();
          const { selectedAnswerCount } = funnelStep;
          // if (selectedAnswerCount) {
          //   dispatch(
          //     PushSelectedAnswerCountToFunnelStep(selectedAnswerCount + 1)
          //   );
          // }

          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const updateUserAnswer = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.updateUserAnswer(data)
      .then((response) => {
        if (response) {
          // dispatch(PushSelectedAnswerCountToFunnelStep());
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const getUserAnswerByAssessmentAttemptId = (
  assessmentAttemptId,
  questionId
) => {
  return function () {
    return AssessmentServiceApi.getUserAnswerByAssessmentAttemptId(
      assessmentAttemptId,
      questionId
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const getUserAnswerByAssessmentAttemptIdAndQuestionId = (
  assessmentAttemptId,
  questionId
) => {
  return function () {
    return AssessmentServiceApi.getUserAnswerByAssessmentAttemptIdAndQuestionId(
      assessmentAttemptId,
      questionId
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const saveAssessmentResult = (assessmentAttemptId) => {
  return function (dispatch) {
    return AssessmentServiceApi.saveAssessmentResult(assessmentAttemptId)
      .then((response) => {
        if (response) {
          dispatch(PushQuizCompleteToFunnelStep(true));
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const getAssessmentAttempt = (assessmentId, userGuid, assessmentAttemptId) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getAssessmentAttempt(
      assessmentId,
      userGuid,
      assessmentAttemptId
    )
      .then((response) => {
        const { funnelStep } = getState();
        if (response && response?.resumeQuestionId) {
          dispatch(
            PushSelectedAnswerCountToFunnelStep(
              Number(response?.resumeQuestionId)
            )
          );
          dispatch(
            PushAnswerCountToFunnelStep(Number(response?.resumeQuestionId))
          );
          return response;
        }
        // if (response && selectedAnswerCount <= totalQuestions) {
        //   dispatch(
        //     PushSelectedAnswerCountToFunnelStep(response?.resumeQuestionId)
        //   );
        //   return response;
        // }
      })
      .catch((error) => console.log("Error"));
  };
};

const createAssessmentAttempt = (data) => {
  return function () {
    return AssessmentServiceApi.createAssessmentAttempt(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const updateAssessmentAttempt = (data) => {
  return function () {
    return AssessmentServiceApi.updateAssessmentAttempt(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const createAssessmentMap = (data) => {
  return function () {
    return AssessmentServiceApi.createAssessmentMap(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const saveRelationshipCompatibilityResult = (assessmentMapId) => {
  return function () {
    return AssessmentServiceApi.saveRelationshipCompatibilityResult(
      assessmentMapId
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};
const saveUserAssessmentResultMaps = (data) => {
  return function () {
    return AssessmentServiceApi.saveUserAssessmentResultMaps(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const PushTotalNumberOfQuestionToFunnelStep = (totalQuestions) => ({
  type: FunnelStepTypes.SET_NUMBER_OF_QUESTIONS,
  totalQuestions,
});
const PushQuizCompleteToFunnelStep = (quizComplete) => ({
  type: FunnelStepTypes.SET_QUIZ_COMPLETE,
  quizComplete,
});

const PushSelectedAnswerCountToFunnelStep = (count) => ({
  type: FunnelStepTypes.SET_SELECTED_ANSWER_COUNT,
  count,
});

const pushResetSelectedAnswerCountToFunnelStep = () => ({
  type: FunnelStepTypes.RESET_SELECTED_ANSWER_COUNT,
});
const PushAnswerCountToFunnelStep = (answerCount) => ({
  type: FunnelStepTypes.SET_ANSWER_COUNT,
  answerCount,
});

export {
  getBulkQuestions,
  saveUserAnswer,
  updateUserAnswer,
  getUserAnswerByAssessmentAttemptIdAndQuestionId,
  saveAssessmentResult,
  getAssessmentAttempt,
  createAssessmentAttempt,
  updateAssessmentAttempt,
  getUserAnswerByAssessmentAttemptId,
  getCareerContent,
  getOneQuestionPerAssessment,
  createAssessmentMap,
  saveUserAssessmentResultMaps,
  saveRelationshipCompatibilityResult,
};
